export default __webpack_public_path__ + "static/desktop_menu_KV10-158f572a86ab2b054c923cec24007d62.mp4";